export const MESSAGE_TEXT = {
  CURRENT_PASSWORD_REQUIRED: 'message.current_password_required',
  EMAIL_NOT_VALID: 'message.email_not_valid',
  EMAIL_REQUIRED: 'message.email_required',
  EMAIL_RESET_PASSWORD_SENT: 'message.email_reset_password_sent',
  ENTER_EMAIL_RESET_PASSWORD: 'message.enter_email_reset_password',
  FIELD_REQUIRED: 'message.field_required',
  NAME_REQUIRED: 'message.name_required',
  NEW_PASSWORD_REQUIRED: 'message.new_password_required',
  PASSWORD_CONFIRM_NOT_MATCH: 'message.password_confirm_not_match',
  PASSWORD_CONFIRM_REQUIRED: 'message.password_confirm_required',
  PASSWORD_RESET_SUCCESS: 'message.password_reset_success',
  ROLE_REQUIRED: 'message.role_required',
  SOMETHING_WRONG: 'message.something_wrong',
  USER_CREATE_SUCCESS: 'message.user_create_success',
}
